import WoosmapMultisearch from '../../data/woosmap/MultisearchTypes'

interface Geometry {
  location: {
    lat: number
    lng: number
  }
}

interface IAutocompleteDetailsProps {
  id: string
  name: string
  geometry: Geometry
  formattedAddress: string
  types: Array<string>
  addressComponents: Array<any>
  item: any
}

class AutocompleteDetails {
  public readonly id: string
  public readonly name: string
  public readonly geometry: {
    location: {
      lat: number
      lng: number
    }
  }
  public readonly formattedAddress: string
  public readonly types: Array<string>
  public readonly addressComponents: Array<any>
  public readonly item: any
  constructor({ id, name, geometry, formattedAddress, types, addressComponents, item }: IAutocompleteDetailsProps) {
    this.id = id
    this.name = name
    this.geometry = geometry
    this.formattedAddress = formattedAddress
    this.types = types
    this.addressComponents = addressComponents
    this.item = item
  }

  public static from(from: WoosmapMultisearch.DetailsResponseItem): AutocompleteDetails {
    return {
      id: from.id,
      name: from.name,
      geometry: from.geometry,
      formattedAddress: from.formatted_address,
      types: from.types,
      addressComponents: from.address_components,
      item: from.item
    }
  }
}

export default AutocompleteDetails
